import { createContext } from 'react';

export const TimeseriesInfiniteZoomContext = createContext<boolean>(false);

TimeseriesInfiniteZoomContext['displayName'] = 'TimeseriesInfiniteZoomContext';
